module.exports = __webpack_public_path__ + "assets/img/Inter-SemiBold.svg?f91d0acb38965d6b9818ab4fc0a96113";